import React, { useEffect, useMemo, useRef, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

import "./ImportVentas.css";
import { toast } from "react-toastify";

const ACCEPT_EXT = [".csv", ".xls", ".xlsx"];
const ACCEPT_MIME = [
    "text/csv",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
];

function isValidFile(file) {
    if (!file) return false;
    const name = (file.name || "").toLowerCase();
    const byExt = ACCEPT_EXT.some((ext) => name.endsWith(ext));
    const byMime = ACCEPT_MIME.includes(file.type);
    return byExt || byMime;
}

export default function ImportVentasModal({
    show,
    banderaSubir,
    toggle,
    onImport,
    onImportSantander,
    loading = false,
}) {
    const inputRef = useRef(null);
    const [dragOver, setDragOver] = useState(false);
    const [file, setFile] = useState(null);
    const [error, setError] = useState("");

    const acceptAttr = useMemo(() => ACCEPT_EXT.join(","), []);

    const resetState = () => {
        setDragOver(false);
        setFile(null);
        setError("");
        if (inputRef.current) inputRef.current.value = "";
    };

    useEffect(() => {
        if (show) resetState();
    }, [show]);

    const close = () => {
        if (loading) return;
        resetState();
        toggle?.();
    };

    const pickFile = () => {
        if (loading) return;
        inputRef.current?.click();
    };

    const setPicked = (f) => {
        if (!f) return;
        if (!isValidFile(f)) {
            setFile(null);
            setError("Archivo no válido. Solo se aceptan .CSV, .XLS o .XLSX.");
            return;
        }
        setError("");
        setFile(f);
    };

    const onChangeInput = (e) => {
        const f = e.target.files?.[0];
        setPicked(f);
    };

    const onDrop = (e) => {
        e.preventDefault();
        if (loading) return;
        setDragOver(false);
        const f = e.dataTransfer.files?.[0];
        setPicked(f);
    };

    const importNow = async () => {
        if (loading) return;

        if (!file) {
            toast.info("Selecciona o arrastra un archivo para importar.");
            return;
        }

        if (error) {
            toast.info("Corrige el archivo seleccionado.");
            return;
        }

        if (banderaSubir == "normal") {

            try {
                await onImport?.(file);
                close();
            } catch (e) {
                toast.error("No se pudo importar el archivo.");
            }
        }
        else {

            try {
                await onImportSantander?.(file);
                close();
            } catch (e) {
                toast.error("No se pudo importar el archivo.");
            }
        }


    };

    return (
        <Modal
            isOpen={!!show}
            toggle={close}
            centered
            size="lg"
            backdrop="static"
            keyboard={!loading}
            className="ivm-rs-modal"
        >
            <ModalHeader toggle={loading ? undefined : close}>
                Importar Ventas
            </ModalHeader>

            <ModalBody>
                <div
                    className={`ivm-dropzone ${dragOver ? "is-over" : ""}`}
                    onDragEnter={(e) => {
                        e.preventDefault();
                        if (!loading) setDragOver(true);
                    }}
                    onDragOver={(e) => {
                        e.preventDefault();
                        if (!loading) setDragOver(true);
                    }}
                    onDragLeave={(e) => {
                        e.preventDefault();
                        setDragOver(false);
                    }}
                    onDrop={onDrop}
                >
                    <div className="ivm-icon" aria-hidden="true">
                        <svg width="64" height="64" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M14 2H7a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7l-5-5Z"
                                stroke="currentColor"
                                strokeWidth="1.6"
                            />
                            <path d="M14 2v5h5" stroke="currentColor" strokeWidth="1.6" />
                            <path
                                d="M8 13h8M8 16h8"
                                stroke="currentColor"
                                strokeWidth="1.6"
                            />
                        </svg>
                    </div>

                    <div className="ivm-mainText">Arrastra y suelta el archivo aquí</div>

                    <button className="ivm-pickBtn" onClick={pickFile} type="button">
                        O haz clic para seleccionar un archivo
                    </button>

                    <div className="ivm-help">
                        Solo se aceptan archivos .CSV, .XLS o .XLSX.
                    </div>

                    <input
                        ref={inputRef}
                        type="file"
                        accept={acceptAttr}
                        onChange={onChangeInput}
                        className="ivm-hiddenInput"
                    />

                    {file && !error && (
                        <div className="ivm-filePill">
                            <span className="ivm-fileName">{file.name}</span>
                            <button
                                className="ivm-remove"
                                onClick={() => resetState()}
                                type="button"
                                aria-label="Quitar archivo"
                                disabled={loading}
                            >
                                ✕
                            </button>
                        </div>
                    )}

                    {error ? <div className="ivm-error">{error}</div> : null}
                </div>
            </ModalBody>

            <ModalFooter className="ivm-footer-rs">
                <Button
                    color="danger"
                    outline
                    onClick={close}
                    disabled={loading}
                    className="ivm-btn"
                >
                    Cancelar
                </Button>

                <Button
                    color="primary"
                    onClick={importNow}
                    disabled={loading}
                    className="ivm-btn"
                >
                    {loading ? "IMPORTANDO..." : "IMPORTAR"}
                </Button>
            </ModalFooter>
        </Modal>
    );
}
